export default function useActionLabel(actionKind) {
  const labels = useSel(s => s.flow.flowTemplate?.labels?.actions || {})
  const customLabel = labels[actionKind]

  if (customLabel) return customLabel

  // Fallback to formatted kind
  return actionKind.charAt(0).toUpperCase() + actionKind.slice(1).replace(/_/g, ' ')
}
